import React from "react";

import { TeaserLink } from "../TeaserLink/TeaserLink";
import { TeaserLinksContainerParams } from "./TeaserLinksContainerParams.csharp";

export const TeaserLinksContainer: React.FC<TeaserLinksContainerParams> = ({
  teaserLinks,
}) => {
  return (
    <div className="offset-lg-up mb-4 mb-lg-5">
      <div className="row row-tight">
        <div className="edge-to-edge-sm col-sm-15 col-md-12 col-lg-9 col-xl-12">
          <div className="row row-tight">
            {teaserLinks.map((tl, i) => (
              <TeaserLink
                key={i}
                label={tl.label}
                link={tl.link}
                imageUrl={tl.imageUrl}
                themeColorValues={tl.themeColorValues}
                customThemeColorInHex={tl.customThemeColorInHex}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
